<div class="favorite-wrapper">
  <div class="table-container">
    <div class="d-flex align-items-start flex-row save-view">
      <input type="text" class="form-control" placeholder="{{'Save new' | translate}}"
             [(ngModel)]="name" maxlength="20">
      <div class="btn-group mr-3">
        <button [attr.data-btnId]="getElementId('saveFavorite')" type="button" class="btn btn-sm btn-success" aria-label="Close"
                (click)="beforeSave(name, false)" placement="right" container="body"
                ngbTooltip="{{ 'Save favorite' | translate}}" [disabled]="!name">
          <i class="far fa-save"></i>
        </button>
        <div class="btn-group" ngbDropdown role="group">
          <button type="button" ngbDropdownToggle *qmAuth="'favorites_all'" [disabled]="!name"
                  class="btn btn-success dropdown-toggle dropdown-toggle-split" aria-controls="dropdown-split">
            <span class="caret"></span>
          </button>
          <div class="dropdown-menu" ngbDropdownMenu>
            <button class="dropdown-item" (click)="beforeSave(name, true)">
              {{'Save as global favorite' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-between name flex-column favorites" *ngFor="let single of favorites">
      <div class="d-flex justify-content-between flex-row"  *ngIf="favorites.length > 0; else elseBlock">
        <div class="">
          <a [attr.data-btnId]="getElementId('restoreFavorite')" (click)="restoreView(single)">{{single.name}}</a>
        </div>
        <div class="align-items-end actions">
          <a [attr.data-btnId]="getElementId('updateFavorite')" (click)="updateFavorite(single)" *qmAuth="'button_write'">
            <svg class="svg-inline--fa fa-w-15">
              <use xlink:href="#save"></use>
            </svg>
          </a>
          <a [attr.data-btnId]="getElementId('removeFavorite')" (click)="deleteView(single)"  *qmAuth="'button_write'">
            <svg class="svg-inline--fa fa-w-15">
              <use xlink:href="#trash"></use>
            </svg>
          </a>
        </div>
      </div>
    </div>
    <ng-template #elseBlock>
      <div class="d-flex justify-content-between name flex-column favorites">
        <i class="fal fa-spinner fa-spin"></i>
      </div>
    </ng-template>
  </div>
</div>

<i class="far fa-save" data-fa-symbol="save"></i>
<i class="far fa-trash-alt" data-fa-symbol="trash"></i>
